<template>
    <div>
        <el-row>
            <div class="model-header">
                <h2>Cập nhật Đề thi {{ modelData.name }}</h2>
                <el-button @click="backModel" size="small" class="btn-back">
                    Trờ về
                </el-button>
            </div>
        </el-row>
        <el-row>
            <div class="model-content">
                <el-col :span="24">
                    <el-form label-position="top" :rules="rules" :model="modelData" ref="updateModel" @submit.native.prevent>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-row :gutter="10">
                                    <el-card class="box-card">
                                        <el-row :gutter="10">
                                            <!-- Tên đề thi -->
                                            <el-form-item prop="name" label="Tên đề thi" class="form-item">
                                            <el-input v-model="modelData.name" placeholder="Tên đề thi" class="input-seach" clearable></el-input>
                                            </el-form-item>
                                        </el-row>

                                        <el-row :gutter="10">
                                            <el-form-item prop="type_time" label="Kiểu đề thi" class="form-item">
                                            <el-select v-model="modelData.type_time" filterable placeholder="Kiểu đề thi" class="input-select">
                                                <el-option
                                                v-for="item in lists.listTypeTime"
                                                :key="item.key"
                                                :label="item.value"
                                                :value="item.key">
                                                </el-option>
                                            </el-select>
                                            </el-form-item>
                                        </el-row>

                                    </el-card>
                                </el-row>
                            </el-col>

                            <el-col :span="12">
                                <el-row :gutter="10">
                                    <el-card class="box-card">
                                        <el-row :gutter="10">
                                            <el-col :span="14">
                                            <el-form-item prop="score_success" label="Điểm đạt (Điểm số cần đạt để qua đề thi)" class="form-item">
                                                <el-select v-model="modelData.score_success" filterable placeholder="Điểm đạt" class="input-select">
                                                <el-option
                                                    v-for="item in lists.listScoreSuccess"
                                                    :key="item.key"
                                                    :label="item.value"
                                                    :value="item.key">
                                                </el-option>
                                                </el-select>
                                            </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row :gutter="10">
                                            <el-col :span="7">
                                                <el-form-item prop="time" label="Thời gian thi (phút)" class="form-item">
                                                    <el-input-number v-model="modelData.time" controls-position="right" :min="0" :max="300"
                                                    auto-complete="off"
                                                    class="input-seach"
                                                    size="small"></el-input-number>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-card>
                                </el-row>
                            </el-col>
                        </el-row>

                        <el-row style="margin-top: 15px;">
                            <el-form-item label="Kích hoạt" prop="status">
                                <el-switch
                                active-color="#13ce66"
                                inactive-color="#7f8c8d"
                                v-model="modelData.status">
                                </el-switch>
                            </el-form-item>
                        </el-row>

                        <el-row>
                            <el-form-item>
                                <el-button :disabled="!canSubmit" :loading="!canSubmit" type="primary" plain size="small"
                                    @click="submitForm('updateModel')"><i class="fa fa-save"></i> Lưu lại</el-button>
                                <el-button type="warning" plain size="small" @click="backModel">Trở về</el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </el-col>
            </div>
        </el-row>

        <el-row>
            <div v-loading="loading" class="columns-container">
                <div class="column">
                    <h3>Nội dung đề thi</h3>
                    <ul class="item-list">
                        <li class="outter-card" v-for="(item, indexQuestion) in modelQuestions" :key="indexQuestion">
                            <button class="button-card">
                                <div class="question"><strong>Câu {{ indexQuestion + 1 }} : </strong>{{ item.text }}</div>
                                <ul class="answers">
                                    <li class="answer-items" v-for="(option, index) in item.options" :key="index">
                                        <label v-if="option.is_answer" style="color: green">
                                        {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                                        </label>
                                        <label v-else>
                                        {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                                        </label>
                                    </li>
                                </ul>
                                <ul class="answers" style="text-align: right !important;">
                                    <el-button type="success" plain size="small" @click="showModel(item)"><i class="fas fa-retweet"></i> Đổi câu khác</el-button>
                                </ul>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </el-row>

        <!-- preview dialog -->
        <el-dialog
            :close-on-click-modal="false"
            :title="'Chọn câu hỏi cần đổi'"
            :visible.sync="dialogVisible"
            top="20px"
            width="85%">
            <div>
                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-form label-position="top" :rules="dialogRules" :model="dialogModel" ref="searchQuestionsDialog" @submit.native.prevent>
                            <el-col :span="12">
                                <el-card class="box-card">
                                    <el-row :gutter="10">
                                        <!-- Chọn trường -->
                                        <el-form-item prop="school_id" label="Chọn trường" class="form-item">
                                            <el-select v-model="dialogModel.school_id" filterable clearable placeholder="Chọn trường" class="input-select">
                                                <el-option
                                                v-for="item in lists.listSchool"
                                                :key="item.id"
                                                :label="'(' + item.id + ') ' + item.name"
                                                :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-row>

                                    <el-row :gutter="10">
                                        <!-- Chọn phân hệ -->
                                        <el-form-item prop="level_id" label="Chọn phân hệ" class="form-item">
                                            <el-select v-model="dialogModel.level_id" filterable clearable placeholder="Chọn phân hệ" class="input-select">
                                                <el-option
                                                v-for="item in lists.listLevel"
                                                :key="item.id"
                                                :label="'(' + item.id + ') ' + item.name"
                                                :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-row>

                                </el-card>
                            </el-col>

                            <el-col :span="12">
                                <el-card class="box-card">
                                    <el-row :gutter="10">
                                        <!-- Chọn môn học -->
                                        <el-form-item prop="course_id" label="Chọn môn học" class="form-item">
                                            <el-select v-model="dialogModel.course_id" filterable clearable placeholder="Chọn môn học" class="input-select">
                                                <el-option
                                                v-for="item in lists.listCourses"
                                                :key="item.id"
                                                :label="'(' + item.id + '-' + item.code + ') ' + item.name"
                                                :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-row>

                                    <el-row :gutter="10">
                                        <!-- Chọn chương -->
                                        <el-form-item prop="chapter_id" label="Chọn chương" class="form-item">
                                            <el-select v-model="dialogModel.chapter_id" filterable clearable placeholder="Chọn chương" class="input-select">
                                                <el-option
                                                v-for="item in lists.listChapters"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-row>

                                </el-card>
                            </el-col>
                        </el-form>
                    </el-col>
                </el-row>

                <el-row :gutter="10" style="margin-top: 15px;">
                    <el-col :span="12">
                        <el-col :span="12">
                            <el-button
                                :disabled="!canSearch"
                                :loading="!canSearch"
                                type="success"
                                icon="el-icon-search"
                                size="small"
                                plain
                                @click="fetchQuestionsDialog('searchQuestionsDialog')"
                            >
                                Tải câu hỏi
                            </el-button>
                        </el-col>

                        <el-col :span="12" style="text-align: right">
                            <el-button
                                :disabled="!canExchange"
                                :loading="!canExchange"
                                type="primary"
                                size="small"
                                plain
                                @click="saveSelectedQuestion()"
                            ><i class="fa fa-save"></i> Lưu lại câu đã chọn</el-button>
                        </el-col>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 15px;">
                    <div v-loading="dialogloading" class="columns-container">
                        <div class="column">
                            <h3>Tổng số câu tìm được: {{ lists.listQuestionsDialog.length }} câu</h3>
                            <el-row>
                                <el-col :span="18">
                                    <label style="color: #67c23a;">(Nhấp chuột chọn câu hỏi muốn đổi)</label>
                                </el-col>
                            </el-row>
                            <ul class="item-list">
                                <li class="outter-card" v-for="item in lists.listQuestionsDialog" :key="item.id">
                                    
                                    <button class="button-card"
                                        :disabled="showSelectedQuestion(item)"
                                        @click="selectDialogItem(item)">
                                        <div class="question">{{ item.text }}</div>
                                        <ul class="answers">
                                        <li class="answer-items" v-for="(option, index) in item.options" :key="index">
                                            <label v-if="option.is_answer" style="color: green">
                                            {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                                            </label>
                                            <label v-else>
                                            {{ String.fromCharCode(65 + index) }}. {{ option.text }}
                                            </label>
                                        </li>
                                        </ul>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small" plain type="info">Cancel</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
  <script>
  import axios from 'axios'
  import { head } from 'lodash'
  import { mapActions } from 'vuex'
  export default {
    name: 'TestKitCreate',
    metaInfo () {
      return {
        title: 'Đề thi trắc nghiệm'
      }
    },
    data () {
      return {
        canSubmit: true,
        canExchange: true,
        loading: false,
        modelQuestions: '',
        dialogloading: false,
        dialogVisible: false,
        canSearch: true,
        dialogTitle: '',
        selectedQuesion: {},
        exchangeIndex: -1,
        dialogModel: {
            school_id: '',
            level_id: '',
            course_id: '',
            chapter_id: ''
        },
        modelData: {
        },
        configData: {
            course: {
                id: 0,
                name: 'Tên khóa này'
            },
            chapter: {
                id: 0,
                name: 'Tên chương này'
            }
        },
        lists: {
            listTypeTime: [
                {key: 0, value: 'Không chọn'},
                {key: 1, value: 'Kiểm tra 15 phút'},
                {key: 2, value: 'Kiểm tra 1 tiết'},
                {key: 12, value: 'Kiểm tra giữa môn'},
                {key: 14, value: 'Kiểm tra kết thúc môn'},
                {key: 15, value: 'Kiểm tra cuối kỳ'}
            ],
            listTypeQuesition: [
                {key: 1, value: 'Trắc nghiệm'},
                {key: 2, value: 'Tự luận'}
            ],
            listScoreSuccess: [
                {key: 0, value: '0 điểm'},
                {key: 0.5, value: '0,5 điểm'},
                {key: 1, value: '1 điểm'},
                {key: 1.5, value: '1.5 điểm'},
                {key: 2, value: '2 điểm'},
                {key: 2.5, value: '2.5 điểm'},
                {key: 3, value: '3 điểm'},
                {key: 3.5, value: '3.5 điểm'},
                {key: 4, value: '4 điểm'},
                {key: 4.5, value: '4.5 điểm'},
                {key: 5, value: '5 điểm'},
                {key: 5.5, value: '5.5 điểm'},
                {key: 6, value: '6 điểm'},
                {key: 6.5, value: '6.5 điểm'},
                {key: 7, value: '7 điểm'},
                {key: 7.5, value: '7.5 điểm'},
                {key: 8, value: '8 điểm'},
                {key: 8.5, value: '8.5 điểm'},
                {key: 9, value: '9 điểm'},
                {key: 9.5, value: '9.5 điểm'},
                {key: 10, value: '10 điểm'}
            ],
            listSchool: [],
            listLevel: [],
            listCourses: [],
            listChapters: [],
            listQuestions: [],
            listQuestionsDialog: [],
        },
        rules: {
            name: [
                { required: true, message: 'Vui lòng nhập tên đề thi' },
                { min: 2, max: 191, message: 'Tên bài học có chiều dài từ 2 tới 191 kí tự' }
            ],
            time: [
                { required: true, message: 'Vui lòng nhập thời gian thi' }
            ]
        },
        dialogRules: {
            school_id: [
                { required: true, message: 'Vui lòng chọn trường' }
            ],
            level_id: [
                { required: true, message: 'Vui lòng chọn phân hệ' }
            ],
            course_id: [
                { required: true, message: 'Vui lòng chọn môn học' }
            ],
        }
      }
    },
    mounted () {
        // this.$refs.myInput.focus()
        this.configBreadcrumb()
        this.fetchModel()
        this.fetchSchool()
    },
    methods: {
        // Lấy action từ Vuex
        ...mapActions(['setBreadcrumb']),
        // Cấu hình dữ liệu về khóa học, bài, cấu hình Breadcrumb
        configDataAndBreadcrumb () {
            this.modelData.course_id = this.$route.params.course_id
            this.modelData.chapter_id = this.$route.params.chapter_id
            this.fetchCourse()
        },
        // Tải dữ liệu Model xuống
        fetchModel () {
            this.canSubmit = false
            axios.get('test-kits/' + this.$route.params.id).then(response => {
            switch (response.code) {
                case 200:
                    this.canSubmit = true
                    this.modelData = response.data
                    this.fetchQuestions()
                    break
                default:
                    this.$notify.error({
                        title: 'Error',
                        message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                    })
                    break
            }
            })
        },
        fetchQuestions () {
            let data = {
              'status': 1,
              'limit': -1,
              'question_ids': this.modelData.list_question_ids,
            }
            this.loading = true
            axios.get('questions', {params: data}).then(response => {
                switch (response.code) {
                    case 200:
                        this.modelQuestions = response.data
                        break
                    default:
                        this.$notify.error({
                            title: 'Error',
                            message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                        })
                        break
                }
                this.loading = false
            })
        },
        fetchSchool () {
            axios.get('schools', {params: {'status': 1, 'limit': -1}}).then(response => {
                switch (response.code) {
                    case 200:
                    this.lists.listSchool = response.data
                    break
                    default:
                    this.$notify.error({
                        title: 'Error',
                        message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                    })
                    break
                }
            })
        },
        fetchLevel () {
            let data = {
                'status': 1,
                'limit': -1,
                'school_id': this.dialogModel.school_id
            }
            axios.get('levels', {params: data}).then(response => {
                switch (response.code) {
                    case 200:
                        this.lists.listLevel = response.data
                        break
                    default:
                        this.$notify.error({
                            title: 'Error',
                            message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                        })
                        break
                }
            })
        },
        fetchAllCourses () {
            axios.get('levels/all-courses/' + this.dialogModel.level_id).then(response => {
                switch (response.code) {
                    case 200:
                        this.lists.listCourses = response.data
                        break
                    default:
                        this.$notify.error({
                            title: 'Error',
                            message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                        })
                        break
                }
            })
        },
        fetchChapter () {
            let data = {
                'status': 1,
                'limit': -1,
                'course_id': this.dialogModel.course_id
            }
            axios.get('chapters', {params: data}).then(response => {
                switch (response.code) {
                    case 200:
                        this.lists.listChapters = response.data
                        break
                    default:
                        this.$notify.error({
                            title: 'Error',
                            message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                        })
                        break
                }
            })
        },
        fetchQuestionsDialog (formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                let data = {
                    'status': 1,
                    'limit': -1,
                    'course_id': this.dialogModel.course_id,
                    'chapter_id': this.dialogModel.chapter_id
                }
                this.dialogloading = true
                this.canSearch = false
                axios.get('questions', {params: data}).then(response => {
                    switch (response.code) {
                        case 200:
                            this.lists.listQuestionsDialog = response.data
                            break
                        default:
                            this.$notify.error({
                                title: 'Error',
                                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                            })
                            break
                    }
                    this.dialogloading = false
                    this.canSearch = true
                })
            } else {
                this.$notify({
                    title: 'Lỗi dữ liệu nhập',
                    message: 'Vui lòng kiểm tra lại thông tin',
                    type: 'warning'
                })
                return false
            }
            })
        },
        showSelectedQuestion (payload) {
            if(payload.id == this.selectedQuesion.id
            && payload.course_id == this.selectedQuesion.course_id
            && payload.lesson_id == this.selectedQuesion.lesson_id) {
                return true;
            }
            return false
        },
        showModel (payload) {
            this.exchangeIndex = this.modelQuestions.findIndex((i) => i.id === payload.id);
            this.selectedQuesion = payload
            this.dialogVisible = true;
        },
        selectDialogItem(item) {
            this.lists.listQuestionsDialog.forEach(item => item.disabled = false);
            item.disabled = true;
            this.selectedQuesion = item;
        },
        saveSelectedQuestion() {
            let duplicateIdx = this.modelQuestions.findIndex((i) => i.id === this.selectedQuesion.id);
            if (duplicateIdx !== -1) {
                this.$notify({
                    title: 'Lỗi dữ liệu',
                    message: 'Câu hỏi thay thế đã tồn tại trong đề thi',
                    type: 'warning'
                })
                return false
            }

            if (this.exchangeIndex !== -1) {
                this.modelQuestions[this.exchangeIndex] = this.selectedQuesion;
                this.dialogVisible = false;
            }
        },
        configBreadcrumb () {
            let breadcrumb = [
            { name: 'home-index', text: 'Trang chủ' },
            { name: 'test-kits-online-index', text: 'Đề thi trắc nghiệm' },
            { name: 'chapters-index', text: 'Chỉnh sửa đề thi' }
            ]
            this.setBreadcrumb(breadcrumb)
        },
        // Nút back lại trang Index
        backModel () {
            this.$router.push({name: 'test-kits-online-index'})
        },
        // Lưu dữ liệu
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.updateModel()
            } else {
                this.$notify({
                title: 'Lỗi dữ liệu nhập',
                message: 'Vui lòng kiểm tra lại thông tin',
                type: 'warning'
                })
                return false
            }
            })
        },
        updateModel () {
            this.canSubmit = false
            this.modelData.list_questions = this.modelQuestions
            axios.put('test-kits/update-v2/' + this.$route.params.id, this.modelData).then(response => {
            this.canSubmit = true
            switch (response.code) {
                case 200:
                this.$notify({
                    title: 'Thành công',
                    message: 'Cập nhật thi thành công',
                    type: 'success'
                })
    
                this.$router.push({name: 'test-kits-online-index'})
                break
                case 422:
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$notify({
                    title: 'Có lỗi xảy ra',
                    message: message,
                    type: 'warning'
                })
                break
                default:
                this.$notify.error({
                    title: 'Error',
                    message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                })
                break
            }
            })
        }
    },
    watch: {
        'dialogModel.school_id': function () {
            this.dialogModel.level_id = ''
            this.lists.listLevel = []

            if (this.dialogModel.school_id) {
                this.fetchLevel()
            }
        },
        'dialogModel.level_id': function () {
            this.dialogModel.course_id = ''
            this.lists.listCourses = []

            if (this.dialogModel.level_id) {
                this.fetchAllCourses()
            }
        },
        'dialogModel.course_id': function () {
            this.dialogModel.chapter_id = ''
            this.lists.listChapters = []
            this.lists.listQuestionsDialog = []

            if (this.dialogModel.course_id) {
                this.fetchChapter()
            }
        },
    }
  }
  </script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
    .model-content {
        padding-top: 15px;
    }
    .course {
        width: 280px;
        height: 200px;
        display: block;
    }

    .form-container {
        display: flex;
        flex-direction: column;
    }

    .input-container {
        margin-bottom: 10px;
    }

    .columns-container {
        display: flex;
        gap: 20px;
        border-top: 1px solid #dcdfe6;
        height: 760px;
    }

    .column {
        flex: 1;
    }

    .item-list {
        max-height: 700px;
        overflow-y: auto;
        padding-inline-start: 0px;
    }

    .question {
        font-weight: bold;
        margin-bottom: 5px;
        text-align: left !important;
        font-size: 14px;
    }

    .answers {
        list-style-type: none;
        padding-left: 0;
        margin-top: 0;
        text-align: left !important;
        font-size: 14px;
    }

    button {
        margin-top: 10px;
    }

    .outter-card {
        width: 100%;
        list-style-type: none;
        margin-bottom: 5px;
        background-image: none;
    }
    .answer-items {
        padding: 3px;
    }

    .column-title {
        display: block;
        font-size: 1.17em;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: bold;
    }

    .button-card {
        /* border: none !important; */
        padding: 10px 6px 10px 6px;
        border: 1px solid #dcdfe6 !important;
        background-color: #fff;
        margin-top: 0px;
        width: 100%;
        border-radius: 4px;
    }
    .button-card:disabled {
        border: 2px solid #67c23a !important;
    }

    ul {
        list-style-type: none;
    }

    .questions-list-preview {
        height: 720px;
        overflow-y: scroll;
    }

    .el-input-number--small {
        width: 100% !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/test-kits-online/MultipleChoiceManualUpdate.vue